import styled, { css } from 'styled-components';
import { TextBlockProps } from '../types/Article.types';

const lineClamp = (linesQuantity: number) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${linesQuantity};
  -webkit-box-orient: vertical;
`;

export const ArticleWrapper = styled.div<{
  direction: 'ltr' | 'rtl';
  animated: true | false;
}>`
  ${props =>
    props.animated &&
    css`
      @media only screen and (min-width: 1151px) {
        transition: all 0.2s ease-in-out;
        :hover {
          transform: scale(1.05);
        }
      }
    `};

  a {
    text-decoration: none !important;
    display: flex;
    direction: ${props => props.direction};
    width: 100%;
  }

  [class*='Containerstyle__Container-sc'] {
    width: 100%;
    padding: 20px;

    @media only screen and (max-width: 794px) {
      padding: 30px;
    }
  }

  [class*='SimpleGridstyle__SimpleGrid-sc'] {
    @media only screen and (max-width: 794px) {
      flex-direction: column-reverse;
      justify-content: flex-end;
    }

    [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
      @media only screen and (max-width: 794px) {
        width: 100%;
        margin: 0;
      }
    }
  }
`;

export const imageBlock = css`
  object-fit: cover;
  object-position: 50% 50%;
  width: 100%;
  height: 285px;
  border-radius: 6px;

  @media only screen and (max-width: 794px) {
    height: 202px;
    width: 100%;
  }
`;

export const focalPointImageStyle = css`
  height: 285px;
  object-fit: cover;
  width: 100%;
  border-radius: 6px;

  @media only screen and (max-width: 794px) {
    height: 202px;
    width: 100%;
  }
`;

export const TextBlock = styled.div<TextBlockProps>`
  direction: ${props => props.direction};
  text-align: start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 285px;

  @media only screen and (max-width: 794px) {
    padding: 20px 0 0;
    width: 100%;
    min-width: 0;
    height: auto;
  }

  [class*='Headingstyle__Heading-sc'] {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    margin: 22px 0 8px;
    ${lineClamp(2)}

    @media only screen and (max-width: 794px) {
      font-size: 18px;
      font-weight: 700;
      line-height: 28px;
      margin-top: 16px;
    }
  }

  .summary {
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    margin: 0 0 18px 0;
    ${lineClamp(3)}

    @media only screen and (max-width: 794px) {
      ${lineClamp(2)}
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      margin: 0 0 18px 0;
    }
  }
`;

export const TagsBarWrapper = styled.div`
  @media only screen and (max-width: 794px) {
    display: flex;
  }

  .tags {
    border-radius: 13px;
    background-color: #f2f2f2;
    padding: 4px 14px;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0.1px;
    margin-right: 4px;
    margin-bottom: 4px;
    width: fit-content;
    ${lineClamp(1)}

    @media only screen and (max-width: 794px) {
      padding: 6px 11px;
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      margin-bottom: 6px;
    }
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  gap: 20px;

  p {
    margin: 0;
  }

  @media only screen and (max-width: 1320px) {
    gap: 10px;
  }

  @media only screen and (max-width: 1150px) {
    gap: 20px;
  }

  @media only screen and (max-width: 325px) {
    gap: 10px;
  }
`;

export const IconWithTextWrapper = styled.div<{ useSmallerText: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${props =>
    props.useSmallerText
      ? css`
          p {
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            ${lineClamp(1)}

            @media only screen and (max-width: 1190px) {
              font-size: 15px;
              font-weight: 400;
              line-height: 10px;
            }

            @media only screen and (max-width: 1150px) {
              font-size: 16px;
              font-weight: 400;
              line-height: 20px;
            }
          }
        `
      : css`
          p {
            font-size: 18px;
            line-height: 30px;
            letter-spacing: 0.1px;
            ${lineClamp(1)}

            @media only screen and (max-width: 1320px) {
              font-size: 16px;
              font-weight: 400;
              line-height: 20px;
            }
          }
        `};
`;

export const ImageContainer = styled.div`
  display: grid;
  isolation: isolate;
  place-items: start end;

  & > * {
    grid-row: 1 / -1;
    grid-column: 1 / -1;
  }

  & > [data-gatsby-image-wrapper] {
    width: 100%;
  }
`;

export const TagPillWrapper = styled.div<{ direction: 'ltr' | 'rtl' }>`
  z-index: 1;
  margin: ${props =>
    props.direction === 'ltr' ? '0.75rem 0.75rem 0 0' : '0.75rem 0 0 0.75rem'};
`;
